import { Link } from "react-router-dom"
import { MessageSquare } from "lucide-react"
export function Footer() {
  return (
    <>
      <footer className="py-12 text-white bg-brand-nickel">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            <div>
              <div className="flex items-center gap-2">
                <Link to="/">
                  <img
                    src="/images/white-logo.png"
                    alt="Pranaam Hospitals Logo"
                    width={120}
                    height={60}
                    className="h-12 w-auto"
                  />
                </Link>
              </div>
              <p className="text-white/90 mb-4">
                Providing compassionate care and cutting-edge medical services to our community.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Discover Pranaam</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/discover/overview" className="text-white/80 hover:text-white transition-colors">
                    Overview
                  </Link>
                </li>
                <li>
                  <Link to="/discover/vision-mission" className="text-white/80 hover:text-white transition-colors">
                    Vision & Mission
                  </Link>
                </li>
                <li>
                  <Link to="/discover/leadership" className="text-white/80 hover:text-white transition-colors">
                    Leadership
                  </Link>
                </li>
                <li>
                  <Link to="/about/Awards" className="text-white/80 hover:text-white transition-colors">
                    Awards
                  </Link>
                </li>
                <li>
                  <Link to="/discover/achievements" className="text-white/80 hover:text-white transition-colors">
                    Achievements
                  </Link>
                </li>
                <li>
                  <Link to="/discover/careers" className="text-white/80 hover:text-white transition-colors">
                    Careers
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Patient Care</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/patient-care/citizens-charter" className="text-white/80 hover:text-white transition-colors">
                    Citizen's Charter
                  </Link>
                </li>
                <li>
                  <Link to="/patient-care/privacy-policy" className="text-white/80 hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/patient-care/refund-cancellation" className="text-white/80 hover:text-white transition-colors">
                    Refund & Cancellation
                  </Link>
                </li>
                <li>
                  <Link to="/patient-care/terms-conditions" className="text-white/80 hover:text-white transition-colors">
                    Terms & Conditions
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Academics & Research</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/academics/knowledge" className="text-white/80 hover:text-white transition-colors">
                    Pranaam Knowledge
                  </Link>
                </li>
                <li>
                  <Link to="/academics/research" className="text-white/80 hover:text-white transition-colors">
                    Research and Innovations
                  </Link>
                </li>
                <li>
                  <Link to="/academics/excellence-report" className="text-white/80 hover:text-white transition-colors">
                    Excellence Report
                  </Link>
                </li>
                <li>
                  <Link to="/academics/publications" className="text-white/80 hover:text-white transition-colors">
                    Research Publications
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">Contact Us</h3>
              <address className="not-italic text-white/80">
                <p className="mb-2">Pranaam Hospitals</p>
                <p className="mb-2">Madinaguda, Hyderabad</p>
                <p className="mb-2">Phone: +91 99660 60000</p>
                <p className="mb-2 whitespace-nowrap">Email: info@pranaamhospitals.com</p>
              </address>
            </div>
          </div>

          <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/80">
            <p>&copy; {new Date().getFullYear()} Pranaam Hospitals. All rights reserved.</p>
          </div>
        </div>
      </footer>
      
    </>
  )
}
